import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import useStores from "@hooks/useStores";

const { SITE_NAME } = process.env;

const ContentBreadcrumbs = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	return (
		<React.Fragment>
			<Box my={8}>
				<Breadcrumbs
					separator={<NavigateNextIcon fontSize="small" />}
					aria-label="breadcrumb"
					className={classes.breadcrumb}
				>
					<Link color="secondary" href="/">
						{store.content.site?.toUpperCase()}
					</Link>

					{store.content.contentType}

					<Link
						color="secondary"
						href={
							store.content.contentType === "article" && SITE_NAME === "tutors"
								? "/courses/"
								: store.content.folder
						}
					>
						{store.content.contentType === "article" && SITE_NAME === "tutors"
							? "COURSES"
							: store.content.contentType
									?.toUpperCase()
									.replace("GUIDE", `GUIDES`)}
					</Link>
					<Box display={{ xs: "none", sm: "block" }}>
						{store.content.name?.toUpperCase()}
					</Box>
				</Breadcrumbs>
			</Box>
		</React.Fragment>
	);
};

ContentBreadcrumbs.propTypes = {};
export default ContentBreadcrumbs;
